// src/components/Sidebar/index.tsx
import React, { useState } from "react";
import { useLocation } from "react-router-dom";

interface SidebarProps {
  onSelect: (item: string) => void;
  items: string[];
}

const Sidebar: React.FC<SidebarProps> = ({ onSelect, items }) => {
  const [activeTab, setActiveTab] = useState<string | null>(null);
  const location = useLocation();
  console.log("Location", location);
  const handleSelect = (item: string) => {
    setActiveTab(item);
    onSelect(item);
  };

  return (
    <>
      {location.pathname !== "/prompts" && (
        <aside className="w-96 p-4 bg-secondary-50">
          {/* <button className="mt-4 mb-4 p-2 px-4 bg-gray-100 text-gray-700 rounded-full flex items-center justify-center hover:bg-gray-200">
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path>
          </svg>
          <span>New chat</span>
        </button> */}
          <div className="space-y-4">
            {location.pathname === "/insights" && (
              <>
                <p className="text-secondary-700 mt-8 font-bold">Analysis</p>
                <div className="space-y-1">
                  {items.map((item, index) => (
                    <div
                      key={index}
                      className={`text-secondary-900 px-4 py-3 rounded-full flex items-center whitespace-nowrap overflow-hidden text-ellipsis cursor-pointer ${
                        activeTab === item
                          ? "bg-secondary-200 text-black"
                          : "bg-gray-50 text-black"
                      }`}
                      onClick={() => handleSelect(item)}
                    >
                      <span className="overflow-hidden text-ellipsis text-secondary-900">
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </aside>
      )}
    </>
  );
};

export default Sidebar;
